const KEY = "gatewayKey"

export const UNAUTHORIZED = "gateway:unauthorized"

export const getKey = () => localStorage.getItem(KEY) ?? ""

export const setKey = (key: string) => localStorage.setItem(KEY, key)

export function api(path: string, init?: RequestInit) {
  return fetch(`/api${path}`, {
    ...init,
    headers: { ...init?.headers, authorization: `Bearer ${getKey()}` },
  }).then((res) => {
    if (res.status === 401) {
      localStorage.removeItem(KEY)
      dispatchEvent(new Event(UNAUTHORIZED))
      throw new Error("unauthorized")
    }
    return res
  })
}
